style= require('./status.styl')
- var moment = require('moment')
- var camelCase = require('camelcase')
.season-info(overrided=overrided)
    .league(edit=edit)
      .league-name
          ft-icon(name=`sports--${match.sport}`)
          .name= match?.season?.league && match?.season?.league.name
      .round GW#{match.round}
          if match.stopFeeds
              ft-icon(name='ui--security')
    if edit
      ft-button(
        class = { success: this.filterBop},
        (click)=this.toggleHidebop()
      )= (this.filterBop ? 'Show' : 'Hide') + 'BOP'
      sporty-feeds(match=match)
if match.sport === 'cricket'
    .match-info.block
        .team-info(edit=edit)
            img.team-icon(src=match?.homeTeam?.iconUrl || match.iconUrl,
              class={hide: viewDashboard})
            .team-info-name= match?.homeTeam?.name
        .duration-status
            if match.status !== 'pending'
                .duration= match.liveCount
            else
                .duration= 'vs'
            .match-status(class=match.status)= match.status
        .team-info(edit=edit)
            img.team-icon(src=match?.awayTeam?.iconUrl || match.iconUrl,
               class={hide: viewDashboard})
            .team-info-name= match?.awayTeam?.name
    .match-info
        if match.status
            .home.score
                .main-result= (score[0] || 0) + '/' + (subScore[0] || 0)
                .phase(class={hide: viewDashboard}
                    show=edit && viewDashboard)= '(' + (phases[0] || 0) + '/' + phaseMax + ')'
        else
            .main-result= '-'
            .duration-status
                .duration vs
                .match-status(class=match.status)= match.status
        if match.status !== 'pending'
            .away.score
                .main-result= (score[1] || 0) + '/' + (subScore[1] || 0)
                .phase(class={hide: viewDashboard}
                    show=edit && viewDashboard)= '(' + (phases[1] || 0) + '/' + phaseMax + ')'
        else
            .main-result= '-'
    .bout-section(class={hide: viewDashboard})
        .bout-label= match.cricketType.toUpperCase()
else if match.isDuel

    .match-info.block
        .team-info(edit=edit)
            img.team-icon(src=match?.homeTeam?.iconUrl || match.iconUrl,
               class={hide: viewDashboard})
            .team-info-name= match?.teams[0]?.name
        .duration-status
            if match.tag
                .tag= '#' + match.tag
            if match.groupStage
                .group Group #{match.groupStage}
            if match.playOffStage
                .group Stage #{match.playOffStage}
            if ['football', 'hockey'].includes(match.sport) && match.status !== 'pending'
                .duration= match.liveCount
            else
                .duration= 'vs'
            .match-status(class=match.status)= match.status
        .team-info(edit=edit)
            img.team-icon(src=match?.awayTeam?.iconUrl || match.iconUrl,
               class={hide: viewDashboard})
            .team-info-name= match?.teams[1]?.name
    .match-result(edit=edit)
        if ['mma'].includes(match.sport)
            each score, index in match.score
                if score === 10
                    .text-result Decision
                else if score
                    .text-result= `Win R${score}`
                else
                    .text-result
                if !index
                    .separator= ""
        else if match?.score?.length
            each score, index in match.score
                if match.status !== 'pending'
                    .main-result= score || 0
                if !index
                    .separator= ""

    if match.subScore && match.subScore.length && ['hockey', 'tennis'].includes(match.sport)
        .subscores(class={ hide: !edit })
            each pair in match.subPairs
                .score-pair.block
                    .home.subscore= pair[0] || 0
                    .separator= ""
                    .away.subscore= pair[1] || 0
else
    if match.locations?.startLocation || match.locations?.endLocation
        section.bout-section
            .bout-label= match.locations.startLocation || '?'
            .bout -
            .bout-label= match.locations.endLocation || '?'
    if match.matchType && match.matchType !== 'normal'
        section.bout-section
            .bout-label= match.matchType[0].toUpperCase() + match.matchType.slice(1)
            .bout= match.bout || ''
    if match.matchType === 'climb'
        section.bout-section
            .bout-label Difficulty
            .bout= match.difficulty || 0
    if match.distance && match.sport === 'ski_jump'
        section.bout-section
            .bout-label Hill Record
            .bout= match.distance + 'm'
    else if match.distance
        section.bout-section
            .bout-label Distance
            .bout= match.distance + 'km'
    if match.finishLine
        section.bout-section
            .bout-label Finish Line
            .bout= match.finishLine + 'km'
    if match.periods
        section.bout-section
            .bout-label Races
            .bout= match.periods
    if match.locations?.location
        section.bout-section
            .bout-label Location
            .bout= match.locations.location
    if match.locations?.venue
        section.bout-section
            .bout-label Venue
            .bout= match.locations.venue
    if match.sport === 'golf'
        section.bout-section
          .bout-label Location
          .bout= match.locations?.location
    section
        if match.name
        section.bout-section
            .team.name= match.name
    .duration-status
        .match-status(class=match.status)= match.status
.start-time
    .time= moment(match.startTime).format('Do MMM YYYY, HH:mm (Z)')
    if match.endTime
        .time= moment(match.endTime).format('Do MMM YYYY, HH:mm (Z)')
if match.matchType
  .match-type
    .type= 'Match type: ' + match.matchType[0].toUpperCase() + match.matchType.slice(1)
if !match.matchType && match.sport === 'tennis'
  .match-type
    .type= 'Match type: Set5'
